<template>
  <div class="finish-payment">
    <div class="course-head">
      <div class="course-title max-width-box">
        {{ courseInfo.courseName || "-" }}
      </div>
      <div class="course-rate max-width-box">
        <span style="margin-right: 8px; color: #f48c06">{{
          courseInfo.avgscore
        }}</span>

        <el-rate
          v-model="courseInfo.avgscore"
          disabled
          text-color="#ff9900"
          score-template="{value}"
        >
        </el-rate>
        <span style="height: 100%; width: 1px; margin-right: 16px">|</span>
        <span>{{ courseInfo.viewtimes }} Reviews</span>
      </div>
    </div>

    <div class="finish-payment_contianer max-width-box">
      <el-result
        v-loading="loading"
        :icon="orderStatus === 2 ? 'success' : 'error'"
        :title="orderStatus === 2 ? 'Payment Successful' : 'Payment Failed'"
      >
        <template slot="extra">
          <div class="order-detail">
            <div class="order-detail-item">
              <div class="order-detail-item_title">Order Id:</div>
              <span class="order-detail-item_val">{{ orderDetail.id }}</span>
            </div>

            <div class="order-detail-item">
              <div class="order-detail-item_title">Order Fee:</div>
              <span class="order-detail-item_val price"
                >C$ {{ orderDetail.pay_money | formatMoneyNumber }}</span
              >
            </div>

            <div class="order-detail-item">
              <div class="order-detail-item_title">Order Sessions:</div>
              <span class="order-detail-item_val">{{
                orderDetail.covey_calendars.length +
                (orderDetail.covey_calendars.length > 1
                  ? " sessions"
                  : " session")
              }}</span>
            </div>

            <div class="order-detail-item">
              <div class="order-detail-item_title">Pay Way:</div>
              <img class="paypal-icon" src="@/assets/icon/paypal.svg" />
            </div>
            <div class="order-detail-item">
              <div class="order-detail-item_title">
                Serial Number:&nbsp;&nbsp;&nbsp;
              </div>

              <span class="order-detail-item_val">{{
                orderDetail.paymentId
              }}</span>
            </div>

            <div v-if="orderDetail.pay_time" class="order-detail-item">
              <div class="order-detail-item_title">Pay Time:</div>
              <span class="order-detail-item_val">
                {{ orderDetail.pay_time | formatTime }}
              </span>
            </div>
          </div>

          <el-button type="primary" size="medium" @click="goOrder"
            >View orders</el-button
          >
          <el-button
            type="primary"
            size="medium"
            style="margin-left: 40px"
            @click="goCourses"
            >More courses</el-button
          >
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  filters: {
    formatMoneyNumber(value) {
      if (typeof value === "number" && !isNaN(value)) {
        //必要
        return (Number(value) / 100).toFixed(2);
      } else {
        return "-";
      }
    },
    formatTime(val) {
      if (val && moment(val).isValid()) return moment(val).format("YYYY.MM.DD HH:mm:ss");
      else return "-";
    },
  },
  data() {
    return {
      courseInfo: {},
      orderId: "",
      orderStatus: 2,
      orderDetail: {
        covey_calendars: "",
      },
      loading: true,
    };
  },
  created() {
    if (this.$route.query && this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;
      this.getOrderStatus();
      this.getOrderDetailById();
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    //获取订单状态
    getOrderStatus() {
      this.$api.orderApi.getOrderById({ orderId: this.orderId }).then((res) => {
        if (res.status === "0") {
          this.orderStatus = res.data.order_status;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取订单详情
    getOrderDetailById() {
      this.$api.orderApi
        .getOrderDetail({ orderId: this.orderId })
        .then((res) => {
          if (res.status === "0") {
            this.orderDetail = res.data;
            this.courseInfo = res.data.covey_course;
            this.loading = false;
          }
        });
    },

    goOrder() {
      this.$router.push("/order/purchased");
    },
    goCourses() {
      this.$router.push("/course");
    },
  },
};
</script>

<style lang="scss" scoped>
.finish-payment {
  .finish-payment_contianer {
    padding: 24px 0;
    margin: 24px auto 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    .paypal-icon {
      width: auto;
      height: 36px;
    }
    .order-detail {
      .price {
        font-weight: 600;
        color: #f48c06;
      }
    }
    .order-detail-item_title {
      font-size: 14px;
    }
    .order-detail-item_val {
      font-size: 16px;
    }
    .order-detail-item {
      display: flex;
      justify-content: space-between;
      line-height: 48px;
      height: 48px;
      align-items: center;
    }
    .el-button {
      background: #f48c06;
      border-color: #f48c06;
      margin-top: 40px;
      width: calc(50% - 24px);
    }
  }

  .course-head {
    color: #ffffff;
    box-sizing: border-box;
    padding: 11px 0;
    background: linear-gradient(270deg, #175fa8 0%, #0a3a76 100%);
    .course-title {
      font-size: 24px;
      font-weight: 600;
      line-height: 30px;
    }
    .course-rate {
      height: 20px;
      margin-top: 8px;
      font-size: 14px;
      .el-rate {
        display: inline;
        margin-right: 16px;
      }
      span {
        color: #ffffff;
        vertical-align: middle;
      }
    }
  }
}
</style>